module.exports = __webpack_public_path__ + "static/group-photo-bb4eef22a6d3949c9c116c41e5a5fed5.jpg";